export const MAX_COLUMNS = 5; // set in Prismic
